import React from 'react'

import { Outlet } from 'react-router-dom'

import { useCurrentOrganization } from '@/hooks/useSession'

import useRouteParams from '@/hooks/useRouteParams'

import { useGetProductTopicsQuery } from '@/services/organization/product/topics'
import { usePostProductSnapshotMutation } from '@/services/organization/product/snapshot'

import CircularLoading from '@/components/CircularLoading'

import DocumentWrapper from '../../../components/DocumentWrapper'
import ScreenWrapper from '../../../components/ScreenWrapper'

import WizardQuestionsLayout from '../components/WizardQuestionsLayout'
import PolicyEvaluationCard from '../components/PolicyEvaluationCard'

function WizardProducts(): React.ReactElement {
  const { id: organizationId } = useCurrentOrganization()
  const { productId } = useRouteParams()
  const [
    ,
    { isLoading: isFinalizing },
  ] = usePostProductSnapshotMutation()

  const {
    data: topics,
    isLoading,
  } = useGetProductTopicsQuery(
    {
      params: {
        id: organizationId,
        productId: `${productId}`,
      },
    },
  )

  const hasTopic = !!topics?.data

  if (isLoading && hasTopic) {
    return (
      <DocumentWrapper title='Common Sense Privacy | Privacy Wizard'>
        <ScreenWrapper verticalPadding={false}>
          <CircularLoading />
        </ScreenWrapper>
      </DocumentWrapper>
    )
  }

  return (
    <DocumentWrapper title='Common Sense Privacy | Privacy Wizard'>
      <ScreenWrapper verticalPadding={false}>
        {/*
          Mounted here, once, rather than per wizard page: this component is the element
          for products/:productId, so a single mount covers the product overview, every
          topic and question page, the jurisdictional questions and finalize.
        */}
        <PolicyEvaluationCard productId={productId} />
        {isFinalizing ? <Outlet /> : (
          <WizardQuestionsLayout hasQuestionsFooter={false}>
            <Outlet />
          </WizardQuestionsLayout>
        )}
      </ScreenWrapper>
    </DocumentWrapper>
  )
}

export default React.memo(WizardProducts)
